import { GridColumnProps, GridHeaderCellProps } from "@progress/kendo-react-grid";
import { t } from "i18next";
import { FC } from "react";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { FooterAggregateSum } from "ui/grid/GridFooters";
import { CLASSNAME } from "utils/constant";
import { ColumnMenu, ColumnMenuCheckboxFilter } from "./ColumnMenu";

export const salesNoteJournalGridColumns = (data: any[]): GridColumnProps[] => {
    return [
        {
            field: "noteNumber",
            title: t("Note"),
            width: "120px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "lineNumber",
            title: t("Line"),
            width: "90px",
        },
        {
            field: "landingTime",
            title: t("Date"),
            width: "110px",
            headerClassName: "no-border",
            cells: {
                data: (props) => (
                    <GrideDateFormatter
                        date={props.dataItem.landingTime}
                        formatType={"dd.MM.yyyy"}
                    />
                ),
            },
        },
        {
            field: "vesselRegistrationId",
            title: t("VesselRegistrationNo"),
            width: "120px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "vesselName",
            title: t("VesselName"),
            cells: { data: (props) => <CellPopover {...props} /> },
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "fishingGear",
            title: t("FishingGear"),
            width: "130px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "catchField",
            title: t("CatchAreaShort"),
            width: "90px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "catchAreaZone",
            title: t("Zone"),
            width: "80px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "product",
            title: t("Product"),
            cells: { data: (props) => <CellPopover {...props} /> },
            width: "280px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "packaging",
            title: t("Packaging"),
            width: "130px",
            //columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
        },
        {
            field: "liveWeightKg",
            title: t("Weight"),
            width: "100px",
            cells: {
                data: (props) => <NumericalCell {...props} formatDecimal={2} showZero={false} />,
                headerCell: (props) => <NumericalHeader {...props} />,
                footerCell: (props) => (
                    <FooterAggregateSum
                        props={props}
                        data={data}
                        field={"liveWeightKg"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        position="end"
                    />
                ),
            },
            headerClassName: CLASSNAME.TableNumeric,
            className: `${CLASSNAME.TableNumeric} no-border`,
        },
        {
            field: "averageLiveWeightKg",
            title: t("AverageWeight"),
            width: "90px",
            cells: {
                data: (props) => <NumericalCell {...props} formatDecimal={3} showZero={false} />,
                headerCell: (props) => <NumericalHeader {...props} />,
            },
            headerClassName: CLASSNAME.TableNumeric,
            className: `${CLASSNAME.TableNumeric} no-border`,
        },
        {
            field: "numberOfPieces",
            title: t("Pieces"),
            width: "70px",
            cells: {
                data: (props) => <NumericalCell {...props} formatDecimal={0} showZero={false} />,
                headerCell: (props) => <NumericalHeader {...props} />,
            },
            headerClassName: CLASSNAME.TableNumeric,
            className: `${CLASSNAME.TableNumeric} no-border`,
        },
        {
            field: "price",
            title: t("Price"),
            width: "90px",
            cells: {
                data: (props) => <NumericalCell {...props} formatDecimal={2} />,
                headerCell: (props) => <NumericalHeader {...props} />,
            },
            headerClassName: CLASSNAME.TableNumeric,
            className: `${CLASSNAME.TableNumeric} no-border`,
        },
        {
            field: "amount",
            title: t("Amount"),
            width: "110px",
            cells: {
                data: (props) => <NumericalCell {...props} formatDecimal={2} />,
                headerCell: (props) => <NumericalHeader {...props} />,
                footerCell: (props) => (
                    <FooterAggregateSum
                        props={props}
                        data={data}
                        field={"amount"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        position="end"
                    />
                ),
            },
            headerClassName: CLASSNAME.TableNumeric,
            className: `${CLASSNAME.TableNumeric} no-border`,
        },
    ];
};

const NumericalHeader: FC<GridHeaderCellProps & { style?: React.CSSProperties } & any> = (props) => {
    return (
        <th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
            {props.title}
        </th>
    );
};